import { render, staticRenderFns } from "./airtimehour.vue?vue&type=template&id=45536980&scoped=true"
import script from "./airtimehour.vue?vue&type=script&lang=js"
export * from "./airtimehour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45536980",
  null
  
)

export default component.exports